// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_h4-0";